export function assign<T extends object>(obj: T, values: Partial<T>): T {
  return Object.assign(obj, values)
}

let i = 0
export function uid() {
  return ++i
}
